import React, { useEffect, useRef } from 'react';
import { Clock } from 'lucide-react';

interface AnimatedClockProps {
  size?: number;
  color?: string;
}

const AnimatedClock: React.FC<AnimatedClockProps> = ({ 
  size = 64, 
  color = '#000000' 
}) => {
  const clockRef = useRef<HTMLDivElement>(null);
  const pulseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!clockRef.current || !pulseRef.current) return;

    // Add rotation animation
    const rotationKeyframes = `
      @keyframes clockRotate {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    `;

    // Add pulse animation
    const pulseKeyframes = `
      @keyframes clockPulse {
        0%, 100% {
          transform: scale(1);
          opacity: 0.3;
        }
        50% {
          transform: scale(1.2);
          opacity: 0;
        }
      }
    `;

    // Inject styles
    const style = document.createElement('style');
    style.textContent = rotationKeyframes + pulseKeyframes;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      {/* Pulse ring */}
      <div
        ref={pulseRef}
        className="absolute rounded-full border-2"
        style={{
          width: size * 1.5,
          height: size * 1.5,
          borderColor: color,
          animation: 'clockPulse 2s ease-in-out infinite',
        }}
      />
      
      {/* Rotating clock */}
      <div
        ref={clockRef}
        className="relative z-10"
        style={{
          animation: 'clockRotate 2s linear infinite',
        }}
      >
        <Clock size={size * 0.6} color={color} />
      </div>
    </div>
  );
};

export default AnimatedClock;

